if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScroll = 0;
      this.initialOffset = 0;
      this.originalMenuStructure = null;
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = document.querySelector('.mobile-toggle-wrapper');
      
      // Calcular offset inicial após o DOM estar pronto
      setTimeout(() => {
        this.initialOffset = this.offsetTop;
      }, 100);

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            const isDesktop = window.innerWidth >= 1068;
            // Remover classe is-sticky do header
            if (this.classList) {
              this.classList.remove('is-sticky');
            }
            // Restaurar estrutura original do menu no desktop
            if (isDesktop && this.menu && this.originalMenuStructure) {
              const menuUl = this.menu.querySelector('.mobile-menu');
              if (menuUl) {
                menuUl.innerHTML = this.originalMenuStructure;
              }
            }
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        const isDesktop = window.innerWidth >= 1068;
        
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          if (!isDesktop) {
            document.body.classList.remove('overflow-hidden');
          }
          // Remover classe is-sticky do header
          if (this.classList) {
            this.classList.remove('is-sticky');
          }
          this.toggle.classList.remove('active');
          
          // Restaurar estrutura original do menu no desktop
          if (isDesktop && this.menu && this.originalMenuStructure) {
            const menuUl = this.menu.querySelector('.mobile-menu');
            if (menuUl) {
              menuUl.innerHTML = this.originalMenuStructure;
            }
          }
          
          this.closeAnimation(this.toggle);
        } else {
          if (!isDesktop) {
            document.body.classList.add('overflow-hidden');
          }
          // Adicionar classe is-sticky ao header
          if (this.classList && isDesktop) {
            this.classList.add('is-sticky');
          }
          setTimeout(() => {
            this.toggle.classList.add('active');
            
            // No desktop, reorganizar menu em colunas
            if (isDesktop && this.menu) {
              const menuUl = this.menu.querySelector('.mobile-menu');
              
              // Salvar estrutura original na primeira vez
              if (!this.originalMenuStructure && menuUl) {
                this.originalMenuStructure = menuUl.innerHTML;
              }
              
              const mainMenuItems = this.menu.querySelectorAll('.mobile-menu > li');
              
              // Verificar se já tem colunas criadas
              if (menuUl && !menuUl.querySelector('.mobile-menu-column-1')) {
                const column1 = document.createElement('div');
                column1.className = 'mobile-menu-column-1';
                let subColumnIndex = 1;
                
                mainMenuItems.forEach((item) => {
                  // Verificar se o item tem um details como filho direto
                  const hasDetails = item.querySelector(':scope > details');
                  
                  // Verificar se tem sublinks reais (mais que só o botão voltar)
                  let hasRealSublinks = false;
                  if (hasDetails) {
                    const subMenu = hasDetails.querySelector('.sub-menu');
                    if (subMenu) {
                      const subLinks = subMenu.querySelectorAll('li:not(.parent-link-back)');
                      hasRealSublinks = subLinks.length > 0;
                    }
                  }
                  
                  if (!hasRealSublinks) {
                    // Links simples (sem submenu real) vão para coluna 1
                    // Se tem details mas sem sublinks, converter para link simples
                    if (hasDetails) {
                      const summary = hasDetails.querySelector('summary');
                      let linkText = '';
                      if (summary) {
                        // Clonar para não afetar o original
                        const summaryClone = summary.cloneNode(true);
                        // Remover setas e outros elementos
                        const linkForward = summaryClone.querySelector('.link-forward');
                        if (linkForward) linkForward.remove();
                        linkText = summaryClone.textContent.trim();
                      }
                      
                      // Tentar encontrar URL: buscar link dentro do item ou criar slug
                      let linkUrl = '/';
                      const existingLink = item.querySelector('a');
                      if (existingLink && existingLink.href) {
                        linkUrl = existingLink.href;
                      } else if (linkText) {
                        // Criar slug baseado no título
                        const slug = linkText.toLowerCase()
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, '')
                          .replace(/\s+/g, '-')
                          .replace(/[^\w-]+/g, '');
                        linkUrl = '/' + slug;
                      }
                      
                      // Criar um novo li com apenas o link
                      const newLi = document.createElement('li');
                      const newLink = document.createElement('a');
                      newLink.href = linkUrl;
                      newLink.className = 'link-container';
                      newLink.textContent = linkText;
                      newLink.title = linkText;
                      newLi.appendChild(newLink);
                      
                      column1.appendChild(newLi);
                    } else {
                      column1.appendChild(item);
                    }
                  } else {
                    // Cada item com submenu ganha sua própria coluna
                    subColumnIndex++;
                    const subCol = document.createElement('div');
                    subCol.className = 'mobile-menu-column-' + subColumnIndex;
                    subCol.appendChild(item);
                    menuUl._subColumns = menuUl._subColumns || [];
                    menuUl._subColumns.push(subCol);
                  }
                });
                
                // Limpar menu original e adicionar colunas
                menuUl.innerHTML = '';
                menuUl.appendChild(column1);
                if (menuUl._subColumns) {
                  menuUl._subColumns.forEach(col => menuUl.appendChild(col));
                  menuUl._subColumns = null;
                }
              }
              
              // Abrir todos os details
              const menuDetails = this.menu.querySelectorAll('details');
              menuDetails.forEach(detail => {
                detail.setAttribute('open', '');
              });
              
              // Esconder botões de voltar
              const backButtons = this.menu.querySelectorAll('.parent-link-back');
              backButtons.forEach(btn => {
                btn.style.display = 'none';
              });
              
              // Forçar submenus a ficarem visíveis
              const subMenus = this.menu.querySelectorAll('.sub-menu');
              subMenus.forEach(submenu => {
                submenu.style.position = 'static';
                submenu.style.transform = 'none';
                submenu.style.visibility = 'visible';
                submenu.style.opacity = '1';
              });
            }
          }, 10);
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Fechar menu dropdown quando clicar fora (apenas desktop)
      document.addEventListener('click', (e) => {
        const isDesktop = window.innerWidth >= 1068;
        if (isDesktop && this.toggle.classList.contains('active')) {
          if (!this.toggle.contains(e.target)) {
            // Remover classe is-sticky do header
            if (this.classList) {
              this.classList.remove('is-sticky');
            }
            // Restaurar estrutura original do menu no desktop
            if (this.menu && this.originalMenuStructure) {
              const menuUl = this.menu.querySelector('.mobile-menu');
              if (menuUl) {
                menuUl.innerHTML = this.originalMenuStructure;
              }
            }
            this.toggle.classList.remove('active');
            this.closeAnimation(this.toggle);
          }
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });
      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        const currentScroll = window.scrollY;
        const scrollingUp = currentScroll < this.lastScroll;
        const scrollingDown = currentScroll > this.lastScroll;
        
        // Só adiciona sticky se estiver rolando para CIMA e passou do topo
        if (scrollingUp && currentScroll > this.initialOffset) {
          this.classList.add('is-sticky');
          this.classList.remove('is-scrolling-down');
        } 
        // Adiciona classe de scroll down se rolar para BAIXO
        else if (scrollingDown && currentScroll > this.initialOffset) {
          this.classList.remove('is-sticky');
          this.classList.add('is-scrolling-down');
        }
        // Remove ambas as classes se estiver no topo
        else if (currentScroll <= this.initialOffset) {
          this.classList.remove('is-sticky');
          this.classList.remove('is-scrolling-down');
        }
        
        this.lastScroll = currentScroll;
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty('--announcement-height', h + 'px');
      }

    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');

      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}